// 上下架状态
export const upFlagStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '上架',
    value: 1
  },
  {
    name: '下架',
    value: 2
  },
  {
    name: '强制下架',
    value: 3
  }
];
// 用户状态
export const lockStatus00 = [
  {
    name: '用户状态',
    value: ''
  },
  {
    name: '启用',
    value: 1
  },
  {
    name: '禁用',
    value: 2
  }
];
// 车辆管理
export const carType = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '车牌号',
    value: 1
  },
  {
    name: '联系人',
    value: 2
  },
  {
    name: '手机号',
    value: 3
  }
];
export const carSource = [
  {
    name: '信息来源',
    value: ''
  },
  {
    name: '云ERP',
    value: 1
  },
  {
    name: '云管理平台',
    value: 2
  }
];
// 用户状态
export const lockStatus02 = [
  {
    name: '角色状态',
    value: ''
  },
  {
    name: '启用',
    value: 1
  },
  {
    name: '禁用',
    value: 2
  }
];
// 默认版本
export const defaultFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否',
    value: 2
  }
];
// 是否收费1：免费 2：收费
export const feeFlag = [
  {
    name: '免费',
    value: 1
  },
  {
    name: '收费',
    value: 2
  }
];
// 用户状态
export const lockStatus01 = [
  {
    name: '启用',
    value: 1
  },
  {
    name: '禁用',
    value: 2
  }
];
// 商品审核状态
export const proStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  }
];
// 入驻状态
export const venSatatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  },
  {
    name: '已签订',
    value: 4
  }
];
// 入驻来源
export const venSource = [
  {
    name: '全部',
    value: ''
  },
  {
    name: 'pc',
    value: 1
  },
  {
    name: '微信',
    value: 2
  }
];
// 冻结状态
export const venFreezeStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未冻结',
    value: 1
  },
  {
    name: '已冻结',
    value: 2
  }
];
// 定价方式
export const priceMethod = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '询报价',
    value: 1
  },
  {
    name: '一口价',
    value: 2
  },
  {
    name: '面议',
    value: 3
  }
];
// 商户性质
export const venTypeData = [
  {
    name: '自营',
    value: 1
  },
  {
    name: '三方',
    value: 2
  }
];
// 商户性质（订单中心）
export const ordervenTypeData = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '自营',
    value: 1
  },
  {
    name: '三方',
    value: 2
  }
];
// 支付方式
export const payTypeData = [
  {
    name: '在线支付',
    value: 1
  },
  {
    name: '货到付款',
    value: 2
  }
];
// 支付类型(订单中心)
export const orderPayType = [
  {
    name: '货到付款',
    value: 1
  },
  {
    name: '在线支付',
    value: 4
  }
];
// 支付类型(订单中心销售订单)
export const orderListPayType = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '货到付款',
    value: 1
  },
  {
    name: '在线支付',
    value: 4
  }
];
// 是否开启分销
export const disFlag = [
  {
    name: '开启',
    value: 1
  },
  {
    name: '未开启',
    value: 2
  }
];
// 是否可提现
export const wdFlag = [
  {
    name: '不可提现',
    value: 1
  },
  {
    name: '可提现',
    value: 2
  }
];
// 必须为整数金额
export const wdIntFlag = [
  {
    name: '不限',
    value: 1
  },
  {
    name: '必须为整数金额',
    value: 2
  }
];
// 提现周期
export const wdCycle = [
  {
    name: '每天',
    value: 1
  },
  {
    name: '每周',
    value: 2
  },
  {
    name: '每月',
    value: 3
  }
];
// 取货天
export const pickingDay = [
  {
    name: '明天',
    value: 1
  },
  {
    name: '后天',
    value: 2
  }
];
// 取货时间段
export const pickingSpan = [
  {
    name: '上午',
    value: 1
  },
  {
    name: '下午',
    value: 2
  }
];
//支付方式
export const paymentType = [
  {
    name: '微信支付',
    value: 1
  },
  {
    name: '其他支付',
    value: 2
  }
];
// 佣金是否自动审核
export const disAuditFlag = [
  {
    name: '自动',
    value: 1
  },
  {
    name: '手动',
    value: 2
  }
];
// 返佣模式1 按单 2 按月总金额
export const disCloseType = [
  {
    name: '按单',
    value: 1
  }
  // {
  //   name: '按月总金额',
  //   value: 2
  // }
];
// 增加&减少
export const addOrReduceFlag = [
  {
    name: '增加',
    value: 1
  },
  {
    name: '减少',
    value: 2
  }
];
// 成为分销条件
export const disCondition = [
  // {
  //   name: '指定分销人员',
  //   value: 1
  // },
  // {//暂时屏蔽
  //   name: '满足条件',
  //   value: 2
  // },
  {
    name: '人人分销',
    value: 3
  }
];
// 商品计价方式
export const pricingType = [
  {
    name: '数量',
    value: 2
  },
  {
    name: '重量',
    value: 1
  }
];
// 贮存条件
export const reserveCondition = [
  {
    name: '常温'
  },
  {
    name: '冷冻'
  },
  {
    name: '冷藏'
  }
];
// 计量单位
export const pricingTypeInfoMap = {
  1: [
    '斤',
    '克',
    '千克'
  ],
  2: [
    '双',
    '份',
    '件',
    '块',
    '箱',
    '袋',
    '瓶',
    '个',
    '包',
    '盒',
    '桶',
    '只',
    '支',
    '头',
    '条',
    '台'
  ]
};
export const activeFlag =[
  {
    name: '直播中',
    value: 1
  },
  {
    name: '回放',
    value: 2
  },
  {
    name: '预告',
    value: 3
  }
];

// 售卖方式 1 散装 2 包装
export const sellType = [
  {
    name: '散装',
    value: 1
  },
  {
    name: '包装',
    value: 2
  }
];
// 保质期单位 年/月/天
export const shelfLifeUnit = [
  {
    name: '年'
  },
  {
    name: '月'
  },
  {
    name: '天'
  }
];

// 采购业务状态
export const frozenFlag = [
  {
    name: '冻品',
    value: 1
  },
  {
    name: '鲜品',
    value: 2
  },
  {
    name: '冻鲜品',
    value: 3
  }
];

// 报价失效时间
export const failureTime = [
  {
    name: '1小时',
    value: 1
  },
  {
    name: '2小时',
    value: 2
  },
  {
    name: '4小时',
    value: 4
  },
  {
    name: '8小时',
    value: 8
  },
  {
    name: '12小时',
    value: 12
  },
  {
    name: '24小时',
    value: 24
  },
  {
    name: '48小时',
    value: 48
  }
];

// 供应商运营模式
export const autoOperationFlag = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '自运营',
    value: 1
  },
  {
    name: '代运营',
    value: 2
  }
];

// 是否审核
export const auditFlag = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '免审',
    value: 1
  },
  {
    name: '审核',
    value: 2
  }
];

// 商户登记
export const venGrade = [
  {
    name: '三星',
    value: 1
  },
  {
    name: '四星',
    value: 2
  },
  {
    name: '五星',
    value: 3
  },
  {
    name: '其他',
    value: 4
  }
];

export const venGrades = [{
  name: '全部',
  value: 0
}, ...venGrade];

// 发布状态  文章状态 1.已发布 2.草稿
export const erpappArticleStatus = [
  {
    name: '已发布',
    value: 1
  },
  {
    name: '草稿',
    value: 2
  }
];

// 资质审核状态
export const apStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  }
];
// 是否标准扩展属性
export const normalExtendFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否',
    value: 2
  }
];

// 是否搜索筛选
export const searchFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否',
    value: 2
  }
];

// 是否包邮
export const fareMailFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否',
    value: 2
  }
];

// 邮费计价方式
export const farePricingType = [
  {
    name: '按件',
    value: 1
  },
  {
    name: '按重量',
    value: 2
  }
];

// 是否共享
export const shareFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否',
    value: 2
  }
];
// 验证状态
export const verificationStatus = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '待验证',
    value: 1
  },
  {
    name: '验证通过',
    value: 2
  },
  {
    name: '验证不通过',
    value: 3
  }
];

// 注册来源
export const registeredSources = [
  {
    name: '全部',
    value: ''
  },
  {
    name: 'Android',
    value: 1
  },
  {
    name: 'iPhone',
    value: 2
  },
  {
    name: '微信',
    value: 3
  },
  {
    name: '邀请链接',
    value: 4
  },
  {
    name: '地推活动',
    value: 5
  },
  {
    name: 'PC',
    value: 6
  },
  {
    name: '销售app',
    value: 7
  },
  {
    name: '后台添加',
    value: 9
  }
];

// 用户类型
export const userType = [
  {
    name: '采购商',
    value: 1
  },
  {
    name: '供应商',
    value: 2
  }
];
// 活动类型
export const disType = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '优惠券',
    value: 1
  },
  {
    name: '限时抢购',
    value: 2
  },
  {
    name: '预售',
    value: 4
  }
];
// 发放方式
export const sendType = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '买家领取',
    value: 1
  },
  {
    name: '指定条件发放',
    value: 2
  },
  {
    name: '指定用户发放',
    value: 3
  }
];
// 优惠券类型：1、鲜易券 2、店铺券
export const sendPlat = [
  {
    name: '鲜易券',
    value: 1
  },
  {
    name: '店铺券',
    value: 2
  }
];
// 优惠规则 1 订单满减 2 无门槛
export const useRuleType = [
  {
    name: '订单满减',
    value: 1
  },
  {
    name: '无门槛',
    value: 2
  }
];
// 发放条件：1、满多少发放 2、新用户注册发放 3、管理员发放
export const sendRule = [
  {
    name: '',
    value: 1
  },
  {
    name: '新用户注册发放',
    value: 2
  },
  {
    name: '管理员发放',
    value: 3
  }
];
// 发放状态
export const sendStatus = [
  {
    name: '待发放',
    value: 1
  },
  {
    name: '发放中',
    value: 2
  },
  {
    name: '已发完',
    value: 3
  },
  {
    name: '已结束',
    value: 4
  }
];
// 使用状态
export const useStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '已使用',
    value: 1
  },
  {
    name: '未使用',
    value: 2
  },
  {
    name: '已过期',
    value: 3
  }
];
// 有效时间类型
export const useTimeType = [
  {
    name: '固定时段',
    value: 1
  },
  {
    name: '固定天数',
    value: 2
  }
];
// 使用平台 1全平台 2移动专享 3、鲜易商城 4、销销乐
export const usePlat = [
  {
    name: '全平台',
    value: 1
  },
  // {
  //     name: '移动专享',
  //     value: 2
  // },
  {
    name: '商城',
    value: 3
  },
  // {
  //   name: '销售APP',
  //   value: 4
  // }
];
// 使用范围
export const useRange = [
  {
    name: '全部商品',
    value: 1
  },
  {
    name: '指定品类',
    value: 2
  },
  {
    name: '指定商品',
    value: 3
  }
];
// 短信发送状态
export const smsSendStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '发送成功',
    value: 1
  },
  {
    name: '发送失败',
    value: 2
  }
];
// 会员状态
export const freezeStatus = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '正常',
    value: 1
  },
  {
    name: '冻结',
    value: 2
  }
];
// 展示平台
export const pagePlat = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: 'pc端',
    value: 1
  },
  {
    name: '移动端',
    value: 2
  }
];
// 用户类型状态
export const userTypeStatus = [
  {
    name: '开启',
    value: 1
  },
  {
    name: '关闭',
    value: 2
  }
];
// 意见反馈审核状态
export const dealStatus = [
  {
    name: '待处理',
    value: 1
  },
  {
    name: '已处理',
    value: 2
  }
];
// 适用对象
export const smsSendObj = [
  {
    name: '鲜易商城用户',
    value: 1
  },
  {
    name: '鲜易云ERP用户',
    value: 2
  },
  {
    name: '销销乐用户',
    value: 3
  }
];
// 使用状态
export const smsStatus = [
  {
    name: '使用中',
    value: 1
  },
  {
    name: '已禁用',
    value: 2
  }
];
// 发送数量限制
export const numType = [
  {
    name: '不限制',
    value: 1
  },
  {
    name: '限制',
    value: 2
  }
];
// 配送方式
export const shipType = [
  {
    name: '配送',
    value: 1
  },
  {
    name: '委托自提',
    value: 2
  },
  {
    name: '到店自提',
    value: 3
  }
];
// 是否指定车辆
export const appointCarFlag = [
  {
    name: '可指定车辆',
    value: 1
  },
  {
    name: '不可指定车辆',
    value: 2
  }
];
// 是否指定车辆
export const contentType = [
  {
    name: '商品',
    value: 1
  },
  {
    name: '分类',
    value: 2
  },
  {
    name: '商户',
    value: 3
  },
  {
    name: '链接',
    value: 4
  },
  {
    name: '频道页',
    value: 5
  }
];
// 移动端中心（首页管理-焦点图编辑-选择商品弹框中select勾选项）
export const mobiekeyWordsProNamesel = [
  {
    name: '商品名称',
    value: 1
  },
  {
    name: '商品货号 ',
    value: 2
  }
];
// 移动端中心（热销商品管理-商品推荐-选择商品弹框中select勾选项）
export const mobiekeyWordsProNamese2 = [
  {
    name: '商品名称',
    value: 1
  },
  {
    name: '商品货号 ',
    value: 2
  },
  {
    name: '商品sku编码',
    value: 3
  }
];
// 移动端中心（首页管理-焦点图编辑-选择商户弹框中select勾选项）
export const mobiekeyWordsVenNamesel = [
  {
    name: '商户名称',
    value: 1
  },
  {
    name: '商户账号 ',
    value: 2
  },
  {
    name: '商户id ',
    value: 3
  }
];
// 移动端中心（首页管理-广告位编辑）
export const enabledStatus = [
  {
    name: '启用',
    value: 1
  },
  {
    name: '禁用',
    value: 2
  }
];
// 是否推荐
export const topFlag = [
  {
    name: '推荐',
    value: 1
  },
  {
    name: '不推荐',
    value: 2
  }
];
// 版本名称
export const appNameId = [
  {
    name: '鲜易商城',
    value: 1
  },
  {
    name: '销销乐 ',
    value: 2
  }
];
// 终端系统
export const sysType = [
  {
    name: 'Android',
    value: 1
  },
  {
    name: 'ios ',
    value: 2
  }
];
// 是否强制更新
export const forceUpdateFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否 ',
    value: 2
  }
];
// 平台来源
export const source = [
  {
    name: '全部',
    value: ''
  },
  {
    name: 'pc',
    value: 1
  },
  {
    name: '安卓 ',
    value: 2
  },
  {
    name: 'ios ',
    value: 3
  },
  {
    name: '微信商城 ',
    value: 4
  }
];
// 会员管理 -》意见反馈 下拉搜索
export const memberFeedbackSearch = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '手机号',
    value: 1
  },
  {
    name: '联系人 ',
    value: 2
  },
  {
    name: '反馈内容 ',
    value: 3
  }
];
// 订单中心 -》销售管理 销售订单下拉框
export const orderCenterlistSearch = [
  {
    name: '订单编号',
    value: 1
  },
  // {
  //     name: '关联订单 ',
  //     value: 2
  // },
  {
    name: '客户账号 ',
    value: 3
  },
  {
    name: '商品查询',
    value: 4
  },
  {
    name: '货号查询',
    value: 5
  }
];
// 订单中心 -》销售管理 销售订单（订单类型）下拉框
export const orderCenterTypeSelec = [
  {
    name: '自营冻品',
    value: 1
  },
  {
    name: '自营鲜品 ',
    value: 2
  },
  {
    name: '三方冻品 ',
    value: 3
  },
  {
    name: '三方鲜品',
    value: 4
  }
];
// 订单中心 -》销售管理 销售订单时间是筛选下框
export const orderCenterlistDateType = [
  {
    name: '下单时间',
    value: 1
  },
  {
    name: '支付时间 ',
    value: 2
  },
  {
    name: '发货时间 ',
    value: 3
  },
  {
    name: '完成时间 ',
    value: 4
  }
];
// 订单状态
export const orderStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '售后驳回',
    value: 40
  },
  {
    name: '售后完成',
    value: 30
  },
  {
    name: '退款退货中',
    value: 20
  },
  {
    name: '已完成',
    value: 12
  },
  {
    name: '已锁定',
    value: 11
  },
  {
    name: '已取消',
    value: 10
  },
  {
    name: '取消中',
    value: 9
  },
  {
    name: '待审核',
    value: 7
  },
  {
    name: '已发货',
    value: 6
  },
  {
    name: '待发货',
    value: 5
  },
  {
    name: '支付失败',
    value: 4
  },
  {
    name: '支付中',
    value: 3
  },
  {
    name: '待支付',
    value: 2
  },
  {
    name: '已提交',
    value: 1
  }
];
// 订单来源
export const orderSource = [
  {
    name: '全部',
    value: ''
  },
  {
    name: 'android',
    value: 1
  },
  {
    name: 'ios',
    value: 2
  },
  {
    name: '微信',
    value: 3
  },
  {
    name: 'pc',
    value: 4
  },
  {
    name: '销销乐',
    value: 5
  },
  {
    name: '其它',
    value: 6
  },
  {
    name: '意向单',
    value: 7
  }
];

// 订单来源
export const orderSourceNew = [
  {
    name: '全部',
    value: ''
  },
  {
    name: 'android',
    value: 1
  },
  {
    name: 'ios',
    value: 2
  },
  {
    name: '微信',
    value: 3
  },
  {
    name: 'pc',
    value: 4
  }
];
// 订单来源方式 1：代客下单,2：意向单,3:自主下单'
export const orderSourceTypeNew = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '代客下单',
    value: 1
  },
  {
    name: '意向单',
    value: 2
  },
  {
    name: '自主下单',
    value: 3
  }
];

// 订单类型
export const orderType = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '一口价',
    value: 1
  },
  {
    name: '询报价 ',
    value: 2
  }
];
// 是否众品订单
export const zpOrder = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '是',
    value: 2
  },
  {
    name: '否',
    value: 1
  }
];
// 生成方式
export const orderAutoFlag = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '自动',
    value: 1
  },
  {
    name: '手动',
    value: 2
  }
];
// 付款状态
export const payStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '已支付',
    value: 1
  },
  {
    name: '未支付',
    value: 2
  },
  {
    name: '处理中',
    value: 11
  }
];
// (订单中心询价单下拉框)
export const ordercenterInquirySelec = [
  {
    name: '询价单号',
    value: 1
  },
  {
    name: '订单编号',
    value: 2
  },
  {
    name: '客户账户',
    value: 3
  }
];
// (订单中心询价单时间下拉框)
export const ordercenterdateSearchType = [
  {
    name: '报价时间',
    value: 1
  },
  {
    name: '询价时间',
    value: 2
  }
];
// (订单中心询价状态)
export const inquiryStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '待询价',
    value: 0
  },
  {
    name: '已报价',
    value: 1
  },
  {
    name: '已失效',
    value: 2
  },
  {
    name: '询价中',
    value: 3
  },
  {
    name: '已完成',
    value: 4
  },
  {
    name: '已取消',
    value: 5
  },
  {
    name: '已过期',
    value: 6
  },
  {
    name: '已驳回',
    value: 7
  }
];
// 询价类型
export const inquiryType = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '自提价',
    value: 0
  },
  {
    name: '配送价',
    value: 1
  }
];
// 订单中心（已取消销售订单下拉时间框）
export const cancelOrderDateSelec = [
  {
    name: '下单时间',
    value: 1
  },
  {
    name: '取消时间',
    value: 5
  },
  {
    name: '支付时间',
    value: 3
  }
];
// 当前发起结算状态
export const bkgeStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未发起结算',
    value: 1
  },
  {
    name: '结算中',
    value: 2
  }
];
// 佣金签订方式
export const signWay = [
  {
    name: '按订单实发金额',
    value: 1
  },
  {
    name: '按实发重量（元/吨）',
    value: 2
  },
  {
    name: '按实发数量',
    value: 3
  }
];
// 佣金设置方式
export const bkgeSetWay = [
  {
    name: '按商户设置佣金',
    value: 1
  },
  {
    name: '按分类设置佣金',
    value: 2
  },
  {
    name: '按商品SKU设置佣金',
    value: 3
  }
];
// 结算方式
export const settleWay = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '按固定周期',
    value: 1
  },
  {
    name: '按固定日',
    value: 2
  }
];
// 提现渠道
export const settleChannel = [
  {
    name: '微信',
    value: 1
  },
  {
    name: '银行卡',
    value: 2
  },
  {
    name: '支付宝',
    value:3
  }
];
// 结算周期单位
export const periodUnit = [
  {
    name: '日',
    value: 1
  },
  {
    name: '周',
    value: 2
  },
  {
    name: '月',
    value: 3
  }
];
// 按固定日结算
export const weekDay = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '周一',
    value: 1
  },
  {
    name: '周二',
    value: 2
  },
  {
    name: '周三',
    value: 3
  },
  {
    name: '周四',
    value: 4
  },
  {
    name: '周五',
    value: 5
  },
  {
    name: '周六',
    value: 6
  },
  {
    name: '周日',
    value: 7
  }
];
// 账单确认情况
export const confirmBill = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未确认',
    value: 1
  },
  {
    name: '已确认',
    value: 2
  }
];
// 结账状态
export const pbStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未结账',
    value: 1
  },
  {
    name: '部分结账',
    value: 2
  },
  {
    name: '已结账',
    value: 3
  }
];
// 月份
export const monthFloor = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '1月',
    value: 1
  },
  {
    name: '2月',
    value: 2
  },
  {
    name: '3月',
    value: 3
  },
  {
    name: '4月',
    value: 4
  },
  {
    name: '5月',
    value: 5
  },
  {
    name: '6月',
    value: 6
  },
  {
    name: '7月',
    value: 7
  },
  {
    name: '8月',
    value: 8
  },
  {
    name: '9月',
    value: 9
  },
  {
    name: '10月',
    value: 10
  },
  {
    name: '11月',
    value: 11
  },
  {
    name: '12月',
    value: 12
  }
];
// 复核状态
export const reviewStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未复核',
    value: 1
  },
  {
    name: '已复核',
    value: 2
  },
  {
    name: '复核异常',
    value: 3
  }
];
// 作废状态
export const cancelStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '正常',
    value: 1
  },
  {
    name: '已作废',
    value: 2
  }
];
// 收款状态
export const sbillStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未收款',
    value: 1
  },
  {
    name: '部分收款',
    value: 2
  },
  {
    name: '已收款',
    value: 3
  }
];
// 时间下拉(财务中心收款单列表时间下拉)
export const finaCenterSalesBillTime = [
  {
    name: '发货时间',
    value: 1
  },
  {
    name: '收款时间',
    value: 2
  }
];
// 收款方式
export const sbillPayType = [
  {
    name: '全部',
    value: ''
  },
  {
    name: 'pos',
    value: 1
  },
  {
    name: '微信',
    value: 2
  },
  {
    name: '其它',
    value: 3
  }
];
// 时间下拉(CMS中心内容列表搜索下拉)
export const cmsseleArtiSelec = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '栏目名称',
    value: 1
  },
  {
    name: '标题名称',
    value: 2
  }
];
// 文章状态(CMS中心)
export const cmsArticleStatus = [
  {
    name: '已发布',
    value: 1
  },
  {
    name: '草稿',
    value: 2
  }
];
// 标题/内容(信息中心内容列表搜索下拉)
export const smsTemSelec = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '标题',
    value: 1
  },
  {
    name: '内容',
    value: 2
  }
];
// 结算方式财务我的应付账单
export const purchSettleWay = [
  {
    name: '账期结算',
    value: 1
  },
  {
    name: '预付款',
    value: 2
  },
  {
    name: '现结',
    value: 3
  }
];
// 商户试用申请列表下拉筛选
export const venmanagerType = [
  {
    name: '公司名称',
    value: 1
  },
  {
    name: '联系人姓名',
    value: 2
  },
  {
    name: '联系方式',
    value: 3
  }
];
// 企业性质
export const venProperties = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '公司企业',
    value: 1
  },
  {
    name: '个体工商户',
    value: 3
  },
  {
    name: '个人',
    value: 4
  },
  {
    name: '其他性质',
    value: 9
  }
];
// 用户性质
export const userProperties = [
  {
    name: '个人',
    value: 4
  },
  {
    name: '个体工商户',
    value: 3
  },
  {
    name: '公司企业',
    value: 1
  }
];
// 用户性质（会员中心）
export const userPropertiemerber = [
  {
    name: '个人',
    value: 1
  },
  {
    name: '个体工商户',
    value: 2
  },
  {
    name: '公司企业',
    value: 3
  }
];
// 用户性质
export const userPropertiesmerber = [
  {
    name: '用户性质',
    value: ''
  },
  {
    name: '个人',
    value: 1
  },
  {
    name: '个体工商户',
    value: 2
  },
  {
    name: '公司企业',
    value: 3
  }
];
// 消息适用对象
export const msgSendObj = [
  // {
  //     name: '全部',
  //     value: ''
  // },
  {
    name: '鲜易商城用户',
    value: 1
  },
  {
    name: '销销乐用户',
    value: 2
  }
];
// 消息状态
export const msgStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '使用中',
    value: 1
  },
  {
    name: '已禁用',
    value: 2
  }
];
// 消息发送类型
export const msgsendType = [
  {
    name: '仅展示',
    value: 1
  },
  {
    name: '仅推送',
    value: 2
  },
  {
    name: '展示并推送',
    value: 3
  }
];
// 是否支持跳转(新增消息)
export const jumpFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否',
    value: 2
  }
];
// 通用是否类型
export const yesNoFlag = [
  {
    name: '是',
    value: 1
  },
  {
    name: '否',
    value: 2
  }
];
// 适用类型(新增消息)
export const msgSuitType = [
  {
    name: '订单通知',
    value: 1
  },
  {
    name: '优惠券通知',
    value: 2
  },
  {
    name: '客户通知',
    value: 3
  },
  {
    name: '审批通知',
    value: 4
  },
  {
    name: '求购通知',
    value: 5
  },
  {
    name: '回复通知',
    value: 6
  },
  {
    name: '意向单通知',
    value: 7
  },
  {
    name: '身份认证通知',
    value: 8
  }
];
// 是否读取
export const readFlag = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未读',
    value: 1
  },
  {
    name: '已读',
    value: 2
  }
];
// 月份(首页)
export const homepageMon = [
  {
    name: '一月',
    value: 1
  },
  {
    name: '二月',
    value: 2
  },
  {
    name: '三月',
    value: 3
  },
  {
    name: '四月',
    value: 4
  },
  {
    name: '五月',
    value: 5
  },
  {
    name: '六月',
    value: 6
  },
  {
    name: '七月',
    value: 7
  },
  {
    name: '八月',
    value: 8
  },
  {
    name: '九月',
    value: 9
  },
  {
    name: '十月',
    value: 10
  },
  {
    name: '十一月',
    value: 11
  },
  {
    name: '十二月',
    value: 12
  }
];
// 消息状态
export const syncOrderListsearchType = [
  {
    name: '订单编号',
    value: 1
  },
  {
    name: '客户账号',
    value: 3
  }
];
// 限时抢购列表(筛选项)
export const queryDisSearch = [
  {
    name: '商户/店铺名称',
    value: 1
  },
  {
    name: '活动名称',
    value: 2
  }
];
// 启用状态
export const tempStatus = [
  {
    name: '启用',
    value: 1
  },
  {
    name: '禁用',
    value: 2
  },
  {
    name: '已结束',
    value: 3
  }
];
// 关键词回复类型
export const autoKeywordType = [
  {
    name: '文字消息',
    value: 1
  }
  // {
  //   name: '图片消息',
  //   value: 2
  // }
];
// 菜单类型
export const wxMenuType = [
  {
    name: '关键字',
    value: 1
  },
  // {
  //   name: '图片',
  //   value: 2
  // },
  {
    name: '跳转网页',
    value: 3
  }, {
    name: '小程序',
    value: 4
  }
];
// 账单冲销单(下拉)
export const searchTypeRefund = [
  {
    name: '账单冲销单号',
    value: 1
  },
  {
    name: '关联应付账单号',
    value: 2
  }
];
// 冲销单状态
export const rbStatus = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '未冲销',
    value: 1
  },
  {
    name: '冲销中',
    value: 2
  },
  {
    name: '已冲销',
    value: 3
  },
  {
    name: '已作废',
    value: 4
  }
];
// 商品计价方式
export const pricingTypes = [
  {
    name: '按重量',
    value: 1
  },
  {
    name: '按数量',
    value: 2
  }
];
// 销售方式
export const promotOrderType = [
  {
    name: '抢购',
    value: 1
  },
  {
    name: '普通',
    value: 3
  },
  {
    name: '预售',
    value: 4
  },
  {
    name: '拼团',
    value: 5
  }
];
// 预售页面下拉选项
export const searchTypeSales = [
  {
    name: '商户/店铺名称',
    value: 1
  },
  {
    name: '活动名称',
    value: 2
  }
];

// 设置管理 -- 身份认证开关
export const switchTypes = [
  {
    name: '开启',
    value: 1
  },
  {
    name: '关闭',
    value: 2
  }
];
// 主 营 品 类
export const businessTypes = [
  {
    name: '猪肉',
    value: 1
  },
  {
    name: '禽肉',
    value: 2
  },
  {
    name: '预制品',
    value: 3
  },
  {
    name: '水产',
    value: 4
  }
];
// 会员中心审核状态
export const authenticationFlags = [
  {
    name: '待审核',
    value: 2
  },
  {
    name: '已审核',
    value: 3
  }
];
// 会员中心用户实名认证身份验证状态
export const authenticationmerber = [
  {
    name: '待提交',
    value: 1
  },
  {
    name: '待审核',
    value: 2
  },
  {
    name: '已审核',
    value: 3
  },
  {
    name: '已驳回',
    value: 4
  }
];
// 意向单状态
export const wishStatus = [
  {
    name: '已完成',
    value: 1
  },
  {
    name: '已报价',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  },
  {
    name: '已过期',
    value: 4
  },
  {
    name: '撮合中',
    value: 5
  },
  {
    name: '待撮合',
    value: 6
  },
  {
    name: '已取消',
    value: 7
  }
];
// 意向单下拉查询项
export const lisSearchValue = [
  {
    name: '意向单号',
    value: 1
  },
  {
    name: '订单编号',
    value: 2
  },
  {
    name: '商品名称',
    value: 3
  },
  {
    name: '商品货号',
    value: 4
  },
  {
    name: '客戶帐号',
    value: 5
  },
  {
    name: '收货人姓名',
    value: 6
  },
  {
    name: '客户经理',
    value: 7
  }
];
// 意向单下拉时间标识
export const lisSearchTimeType = [
  {
    name: '报价时间',
    value: 1
  },
  {
    name: '询单时间',
    value: 2
  }
];
// 订单中心订单日志
export const orderLogListType = [
  {
    name: '订单中心',
    value: 'manOrder'
  },
  {
    name: '意向单列表',
    value: 'manWishCode'
  }
];
// 收银台配置 - 客户端
export const cashierClientType = [
  {
    name: '小程序商城',
    value: 1
  },
  {
    name: '商城APP',
    value: 2
  },
  {
    name: 'H5商城',
    value: 3
  }
];
// 收银台配置 - 渠道
export const cashierChannelType = [
  {
    name: '线上',
    value: 1
  },
  {
    name: '线下',
    value: 2
  }
];
// 收银台配置 - 支付方式
//支付类型 5:微信支付 6:余额支付 10:二维码收款 11:线下付款 12:app跳转
export const cashierPayType = [
  {
    name: '微信支付',
    value: 5
  },
  {
    name: '余额支付',
    value: 6
  },
  {
    name: '二维码收款',
    value: 10
  },
  {
    name: '线下支付',
    value: 11
  },
  {
    name: 'app跳转',
    value: 12
  }
];

// 是否本次结算(财务中心)
export const pbMarkSelec = [
  {
    name: '全部',
    value: ''
  },
  {
    name: '否',
    value: 1
  },
  {
    name: '是',
    value: 2
  }
];
// 支付类型
export const secDealWay = [
  {
    name: '企业网银',
    value: 1
  },
  {
    name: '个人网银',
    value: 2
  },
  {
    name: '支付宝',
    value: 3
  },
  {
    name: '微信',
    value: 4
  },
  {
    name: '线下打款',
    value: 5
  }
];
// 支付类型
export const dealWay = [
  {
    name: '网银支付',
    value: 2
  },
  {
    name: '快捷支付',
    value: 5
  },
  {
    name: '扫码支付',
    value: 6
  },
  {
    name: '微信支付',
    value: 8
  },
  {
    name: '网银（无卡）支付',
    value: 9
  },
  {
    name: '扫码收款',
    value: 10
  },
  {
    name: '线下打款',
    value: 11
  },
  {
    name: 'app微信支付',
    value: 99
  }
];
// 支付状态
export const dealState = [
  {
    name: '已支付',
    value: 1
  },
  {
    name: '处理中',
    value: 2
  },
  {
    name: '支付失败',
    value: 3
  },
  {
    name: '已作废',
    value: 4
  },
  {
    name: '未支付',
    value: 5
  }
];
// 是否本次结算(财务中心)
export const billinfoBillstate = [
  {
    name: '已支付',
    value: 1
  },
  {
    name: '支付失败',
    value: 2
  }
];
// 状态 支付中心
export const voucherState = [
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  }
];
// 结算订单 （支付中心筛选条件）
export const payOrderSelec = [
  {
    name: '应付账单',
    value: 1
  },
  {
    name: '结算单号',
    value: 2
  }
];
// 结算类型
export const settleType = [
  {
    name: '自营',
    value: 1
  },
  {
    name: '平台',
    value: 2
  },
  {
    name: '强制转账',
    value: 3
  }
];
// 结算状态
export const settleState = [
  {
    name: '已结算',
    value: 1
  },
  {
    name: '结算失败',
    value: 2
  },
  {
    name: '结算处理中',
    value: 3
  },
  {
    name: '银行受理中',
    value: 4
  }
];
// 提现状态
export const settleStateNew = [
  {
    name: '提现成功',
    value: 1
  },
  {
    name: '提现失败',
    value: 2
  },
  {
    name: '处理中',
    value: 3
  },
  {
    name: '待审核',
    value: 4
  },
  {
    name: '已审核',
    value: 5
  },
  {
    name: '未发起',
    value: 6
  },
  {
    name: '已驳回',
    value: 7
  },
  {
    name: '已作废',
    value: 8
  }
];
// 类型（支付中心））
export const whiteListType = [
  {
    name: '商户',
    value: 1
  },
  {
    name: '供货商',
    value: 2
  }
];
// 类型（支付中心））
export const accType = [
  {
    name: '企业',
    value: 1
  },
  {
    name: '个人',
    value: 2
  }
];

// 状态 （支付中心））
export const whiteListState = [
  {
    name: '启用',
    value: 1
  },
  {
    name: '禁用',
    value: 2
  }
];
// 审核状态 1,待审核  2,已审核  3,已驳回
export const checkState = [
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  },
  {
    name: '已禁用',
    value: 4
  }
];
// 支付管理
export const formIdType = [
  {
    name: '售后单号',
    value: 1
  },
  {
    name: '订单编号',
    value: 2
  },
];
// 业务类型 鲜易网对账
export const recordType = [
  {
    name: '支付',
    value: 1
  },
  {
    name: '退款',
    value: 2
  },
  {
    name: '结算',
    value: 3
  },
  {
    name: '充值',
    value: 4
  },
  {
    name: '提现',
    value: 5
  }
];

// 交易中心
// tradingInformation   支付/退款方式
// 交易方式 2:网银支付 5:快捷支付 6:正扫支付(扫码支付) 10:聚合支付 11:线下打款 99:手机app跳转支付
export const TdealWay = [
  {
    name: '网银支付',
    value: 2
  },
  {
    name: '快捷支付',
    value: 5
  },
  {
    name: '扫码支付',
    value: 6
  },
  {
    name: '扫码收款',
    value: 10
  },
  {
    name: '线下打款',
    value: 11
  },
  {
    name: 'app微信支付',
    value: 99
  }
];
// dealState    支付/退款状态
// 交易状态 1:已支付 2:处理中 3:支付失败 6:已作废 7:未支付
export const TdealState = [
  {
    name: '已支付',
    value: 1
  },
  {
    name: '处理中',
    value: 2
  },
  {
    name: '支付失败',
    value: 3
  },
  {
    name: '已作废',
    value: 6
  },
  {
    name: '未支付',
    value: 7
  }
];
// XdealState    支付/退款状态
// 交易状态 1:待处理 2:已支付 3:已驳回
export const XdealState = [
  {
    name: '待处理',
    value: 1
  },
  {
    name: '已支付',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  }
];
// secDealWay    支付方式
// 支付方式 1:企业网银 2：个人网银  3：支付宝  4：微信 5:线下打款 6:正扫支付 8:公众号支付 9：银联无卡支付
export const TsecDealWay = [
  {
    name: '企业网银',
    value: 1
  },
  {
    name: '个人网银',
    value: 2
  },
  {
    name: '支付宝',
    value: 3
  },
  {
    name: '微信',
    value: 4
  },
  {
    name: '线下打款',
    value: 5
  },
  {
    name: '正扫支付',
    value: 6
  },
  {
    name: '公众号支付',
    value: 8
  },
  {
    name: '银联无卡支付',
    value: 9
  }
];
// orderSource  订单来源
// 订单来源 1：android 2：ios 3：微信 4 : pc 5：代客下单 6：其它 7：意向单
export const TorderSource = [
  {
    name: 'android',
    value: 1
  },
  {
    name: 'ios',
    value: 2
  },
  {
    name: '微信',
    value: 3
  },
  {
    name: 'pc',
    value: 4
  },
  {
    name: '代客下单',
    value: 5
  },
  {
    name: '其它',
    value: 6
  },
  {
    name: '意向单',
    value: 7
  }
];
// payChannel 支付/退款渠道
// 支付渠道 1:中金支付
export const TpayChannel = [
  {
    name: '中金支付',
    value: 1
  }
];
// orderType 订单类型
// 订单类型1:在线支付2:货到付款
export const TorderType = [
  {
    name: '在线支付',
    value: 1
  },
  {
    name: '货到付款',
    value: 2
  }
];

// zjBindState 快捷绑卡状态
// 快捷绑卡状态 1:未绑定2:绑定成功3:绑定处理中4:已删除5:已禁用6:绑卡失败
export const zjBindState = [
  {
    name: '未绑定',
    value: 1
  },
  {
    name: '已启用',
    value: 2
  },
  {
    name: '绑定处理中',
    value: 3
  },
  {
    name: '已解绑',
    value: 4
  },
  {
    name: '已禁用',
    value: 5
  },
  {
    name: '绑卡失败',
    value: 6
  }
];
// refundWay
// 退款方式 1:快捷卡 2:线下 3:微信 4:支付宝
export const refundWay = [
  {
    name: '快捷卡',
    value: 1
  },
  {
    name: '线下',
    value: 2
  },
  {
    name: '微信',
    value: 3
  },
  {
    name: '支付宝',
    value: 4
  }
];
// refundOrder明细列表
// 退款方式 3:支付宝 4:微信
export const refundOrderWay = [
  {
    name: '支付宝',
    value: 3
  },
  {
    name: '微信',
    value: 4
  }
];
// refundStatus
// 退款状态 1:退款成功 2:退款失败 3:退款处理中 4:未退款
export const refundStatus = [
  {
    name: '已退款',
    value: 1
  },
  {
    name: '退款失败',
    value: 2
  },
  {
    name: '处理中',
    value: 3
  },
  {
    name: '未退款',
    value: 4
  }
];
// refundChannel
// 退款渠道 1:中金 2:线下
export const refundChannel = [
  {
    name: '中金',
    value: 1
  },
  {
    name: '线下',
    value: 2
  }
];
// refundType
// 退款类型 1=取消订单退款、2=实发差异退款、3=售后退款、4=售后退货退款
export const refundType = [
  {
    name: '取消订单',
    value: 1
  },
  {
    name: '实发差异',
    value: 2
  },
  {
    name: '退款',
    value: 3
  },
  {
    name: '退货退款',
    value: 4
  }
];
// orderType
// 订单来源1：android 2：ios 3：微信 4 : pc 5：代客下单 6：其它 7：意向单
export const orderSourceType = [
  {
    name: 'android',
    value: 1
  },
  {
    name: 'ios',
    value: 2
  },
  {
    name: '微信',
    value: 3
  },
  {
    name: 'pc',
    value: 4
  },
  {
    name: '代客下单',
    value: 5
  },
  {
    name: '其它',
    value: 6
  },
  {
    name: '意向单',
    value: 7
  }
];
// checkStatus
// 审核状态（1:待提交 2:待采购审核 3:待财务审核 4:采购驳回 5:财务驳回6:已审核 7:待鲜咨达审核 8:鲜咨达驳回）',
export const checkStatus = [
  {
    name: '待提交',
    value: 1
  },
  {
    name: '待采购审核',
    value: 2
  },
  {
    name: '待财务审核',
    value: 3
  },
  {
    name: '采购驳回',
    value: 4
  },
  {
    name: '财务驳回',
    value: 5
  },
  {
    name: '已审核',
    value: 6
  },
  {
    name: '待鲜咨达审核',
    value: 7
  },
  {
    name: '鲜咨达驳回',
    value: 8
  }
];
// purchStatus
// 采购状态(1:待提交 2：审核中 3：采购中 4：正常完成 5：异常完成 6：已作废 7：已删除 )',
export const purchStatus = [
  {
    name: '待提交',
    value: 1
  },
  {
    name: '审核中',
    value: 2
  },
  {
    name: '采购中',
    value: 3
  },
  {
    name: '正常完成',
    value: 4
  },
  {
    name: '异常完成',
    value: 5
  },
  {
    name: '已作废',
    value: 6
  },
  {
    name: '已删除',
    value: 7
  }
];
// addType
// 生成方式(1 自动 ，2 手动)',
export const addType = [
  {
    name: '自动',
    value: 1
  },
  {
    name: '手动',
    value: 2
  }
];
// purchType
// 采购类型（ 1：零采 2：集采 3: 整柜）
export const purchType = [
  {
    name: '零采',
    value: 1
  },
  {
    name: '集采',
    value: 2
  },
  {
    name: '整柜',
    value: 3
  }
];
// 处理状态意见反馈列表
export const feedbackdealState = [
  {
    name: '未处理',
    value: 1
  },
  {
    name: '已处理',
    value: 2
  }
];
// 充值状态 1:充值成功 2:处理中 3:充值失败
export const accountDealState = [
  {
    name: '充值成功',
    value: 1
  },
  // {
  //     name: '处理中',
  //     value: 2
  // },
  {
    name: '充值失败',
    value: 3
  }
];
// 提现状态  1 银行受理中   2 提现失败    3提现处理中
export const accountSettleState = [
  {
    name: '银行受理中',
    value: 1
  },
  {
    name: '提现失败',
    value: 2
  },
  {
    name: '提现处理中',
    value: 3
  }
];
// 资金申请单列表 审批状态
export const financecheckStatus = [
  {
    name: '待提交',
    value: 1
  },
  {
    name: '审批中',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  },
  {
    name: '已作废',
    value: 4
  },
  {
    name: '已完成',
    value: 5
  }
];
// 资金申请单列表 结账状态
export const financepayStatus = [
  {
    name: '未结账',
    value: 1
  },
  {
    name: '已结账',
    value: 2
  },
  {
    name: '部分结账',
    value: 3
  },
  {
    name: '结账失败',
    value: 4
  },
  {
    name: '处理中',
    value: 5
  }
];
// 资金申请单列表 付款类型
export const financepaypayType = [
  {
    name: '中金',
    value: 1
  }
];
// 资金申请单列表 公司归属
export const companyBelong = [
  {
    name: '河南鲜易网络科技有限公司',
    value: 1
  },
  {
    name: '河南鲜易网络许昌分公司',
    value: 2
  }
];
// 资金申请单列表 票据类型
export const financebillType = [
  {
    name: '无票',
    value: 1
  },
  {
    name: '专票',
    value: 2
  },
  {
    name: '普票',
    value: 3
  }
];
// 资金申请单列表 收款单位类型
export const financerecType = [
  {
    name: '个人',
    value: 1
  },
  {
    name: '企业',
    value: 2
  }
];
// 资金申请单列表 付款类型
export const financepayType = [
  {
    name: '中金',
    value: 1
  }
];
// 财务中心 三方资金申请(下拉筛选页面)
export const platFunAppSelecPage = [
  {
    name: '三方平台资金申请单(发起人)',
    value: 1
  },
  {
    name: '三方平台资金申请单(审批人)',
    value: 2
  },
  {
    name: '三方平台资金申请单(结算人)',
    value: 3
  }
];
// 财务中心 三方资金申请(下拉筛选页面)
export const selfEmployedSelecPage = [
  {
    name: '自营零采资金申请单(发起人)',
    value: 1
  },
  {
    name: '自营零采资金申请单(审批人)',
    value: 2
  },
  {
    name: '自营零采资金申请单(结算人)',
    value: 3
  }
];
// 财务中心     强制转账(下拉筛选页面)
export const compulsorySelecPage = [
  {
    name: '强制转账金申请单(发起人)',
    value: 1
  },
  {
    name: '强制转账金申请单(审批人)',
    value: 2
  },
  {
    name: '强制转账金申请单(结算人)',
    value: 3
  }
];
// 财务中心 处理状态
export const taskStatus = [
  {
    name: '未处理',
    value: 2
  },
  {
    name: '已处理',
    value: 3
  }
];
// 财务中心 审批状态
export const approOpt = [
  {
    name: '拒绝',
    value: 1
  },
  {
    name: '通过',
    value: 2
  }
];

// 竞拍状态 1:待提交 2:未开始 3:竞拍中 4:竞拍结束 5:竞拍成交 6:流拍
export const bidStatus = [
  {
    name: '待提交',
    value: 1
  },
  {
    name: '未开始',
    value: 2
  },
  {
    name: '竞拍中',
    value: 3
  },
  {
    name: '竞拍结束',
    value: 4
  },
  {
    name: '竞拍成交',
    value: 5
  },
  {
    name: '流拍',
    value: 6
  }
];
// 是否现货 1:现货 2:期货
export const stockFlag = [
  {
    name: '现货',
    value: 1
  },
  {
    name: '期货',
    value: 2
  }
];
// 物流设置状态  1：已设置  2.已作废
export const createLogisticType = [
  {
    name: '已设置',
    value: 1
  },
  {
    name: '已作废',
    value: 2
  }
];
// 导航分类1首页按钮导航 2 个人中心按钮导航 3 首页轮播banner广告 4 活动区域广告图片 5精品推荐轮播图
// 6 热销榜单轮播图 7新品首发轮播图 8促销单品轮播图 9秒杀
export const navType = [
  {
    name: '首页按钮导航',
    value: 1
  },
  {
    name: '个人中心按钮导航',
    value: 2
  },
  {
    name: '首页轮播banner广告',
    value: 3
  },
  {
    name: '活动区域广告图片',
    value: 4
  },
  {
    name: '首页精品推荐轮播图',
    value: 5
  },
  {
    name: '热销榜单轮播图',
    value: 6
  },
  {
    name: '新品首发轮播图',
    value: 7
  },
  {
    name: '促销单品轮播图',
    value: 8
  },
  {
    name: '秒杀图片',
    value: 9
  },
  {
    name: '第1部分',
    value: 10
  },
  {
    name: '第2部分',
    value: 11
  },
  {
    name: '第3部分',
    value: 12
  },
  {
    name: '第4部分',
    value: 13
  },
  {
    name: '第5部分',
    value: 14
  },
  {
    name: '第6部分',
    value: 15
  },
  {
    name: '第7部分',
    value: 16
  },
  {
    name: '第8部分',
    value: 17
  },
  {
    name: '第9部分',
    value: 18
  },
  {
    name: '第10部分',
    value: 19
  },
  {
    name: '第11部分',
    value: 20
  },
  {
    name: '第12部分',
    value: 21
  },
  {
    name: '第13部分',
    value: 22
  },
  {
    name: '第14部分',
    value: 23
  },
  {
    name: '第15部分',
    value: 24
  },
  {
    name: '第16部分',
    value: 25
  },
  {
    name: '第17部分',
    value: 26
  }
  ];


// 客服中心-售后单列表(售后单状态)
export const afterSaleStatus = [
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '审核中',
    value: 3
  },
  {
    name: '已驳回',
    value: 4
  },
  {
    name: '已作废',
    value: 5
  },
  {
    name: '退款成功',
    value: 6
  },
  {
    name: '退款失败',
    value: 7
  },
  {
    name: '退款中',
    value: 8
  }
];
// 客服中心-售后单列表(售后单类型)
export const afterSaleType = [
  {
    name: '仅退款',
    value: 1
  },
  {
    name: '退款退货',
    value: 2
  }
];
// 客服中心-售后单列表(售后原因)
export const afterSaleReason = [
  {
    name: '商品损坏',
    value: 1
  },
  {
    name: '商品错误',
    value: 2
  },
  {
    name: '无条件退款',
    value: 3
  },
  {
    name: '其他原因',
    value: 4
  }
];
// 客服中心-客服审核状态
export const serviceCheckStatus = [
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  }
];
// 客服中心-财务审核状态
export const financeCheckStatus = [
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  }
];
// 客服中心-采购审核状态
export const purchaseCheckStatus = [
  {
    name: '待审核',
    value: 1
  },
  {
    name: '已审核',
    value: 2
  },
  {
    name: '已驳回',
    value: 3
  }
];

// 支付渠道
export const payChannel = [
  {
    name: '支付宝',
    value: 1
  },
  {
    name: '微信',
    value: 2
  },
  {
    name: '余额',
    value: 3
  },
  {
    name: '网银支付',
    value: 4
  }
];


// 退款单列表时间下拉框值
export const formTimeType02 = [
  {
    name: '创建时间',
    value: 1
  },
  {
    name: '退款时间',
    value: 2
  }
];

// 退款单列表
export const formIdType03 = [
  {
    name: '退款单号',
    value: 1
  },
  {
    name: '售后单号',
    value: 2
  },
  {
    name: '订单编号',
    value: 3
  },
  {
    name: '商品名称',
    value: 4
  },
  {
    name: '商品货号',
    value: 5
  },
  {
    name: '客户账号',
    value: 6
  },
  {
    name: '退货单号',
    value: 7
  }
];


// 退款状态
export const refundStatus02 = [
  {
    name: '待确认退款',
    value: 1
  },
  {
    name: '已确认退款',
    value: 2
  },
  {
    name: '退款失败',
    value: 3
  },
  {
    name: '退款处理中',
    value: 4
  },
  {
    name: '拒绝退款',
    value: 5
  },
  {
    name: '退款成功',
    value: 7
  }
];





// WEBPACK FOOTER //
// ./src/dataControl.js